import { AsyncPipe, CommonModule, DatePipe } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, inject, Input } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

import { Store } from '@ngrx/store';

import { Observable } from 'rxjs';

import { OrdersActions } from '../../../../@store/orders/orders.actions';
import { Note, singleOrderDetails } from '../../../../@store/orders/orders.model';
import { selectAddNoteLoading, selectOrderDetails } from '../../../../@store/orders/orders.selectors';

@Component({
  selector: 'ciwc-order-note-history',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    MatFormFieldModule,
    MatInputModule,
    MatButtonModule,
    MatProgressSpinnerModule,
    DatePipe,
    AsyncPipe,
  ],
  standalone: true,
  templateUrl: './order-note-history.component.html',
  styleUrl: './order-note-history.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderNoteHistoryComponent implements AfterViewInit {
  @Input() orderDetails!: singleOrderDetails | null;
  @Input() viewDisable!: boolean;

  private store = inject(Store);

  noteForm = new FormGroup({
    noteInput: new FormControl({ value: '', disabled: this.viewDisable }, [
      Validators.required,
      Validators.maxLength(1000),
    ]),
  });

  addNoteLoading$: Observable<boolean> = this.store.select(selectAddNoteLoading);
  orderDetailsFromStore$: Observable<singleOrderDetails | undefined> = this.store.select(selectOrderDetails);

  ngAfterViewInit() {
    if (this.viewDisable) {
      this.noteForm.get('noteInput')?.disable();
    } else {
      this.noteForm.get('noteInput')?.enable();
    }
  }

  trackByNoteId(index: number, note: Note) {
    return note.id || index;
  }

  onSaveNote() {
    const noteValue = this.noteForm.get('noteInput')?.value?.trim();
    // Use the most current order details (from store or input)
    const currentOrder = this.orderDetails;
    if (!noteValue || !currentOrder) return;
    this.store.dispatch(
      OrdersActions.addOrderNote({ orderId: currentOrder.id, note: noteValue }),
    );
    this.noteForm.reset();
  }
}
